import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dasherDate',
})
export class DasherDatePipe extends DatePipe implements PipeTransform {
  transform(value: any, args: any): string {
    if (!value || value.toString() === '[object Object]') return '--';
    else return super.transform(value, args);
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/pipes/secure/dasher-date.pipe.ts